<template>
    <div>
        <q-card class="bg-accent"  >
            <q-card-section>
                <q-form @submit="onSubmit" class="q-gutter-lg">
                    <div class="row">
                        <div class="col userID" >
                            <q-input key="text" outlined  v-model="StoreStateAOD.ResetUsername"  disable readonly label="Username" color="black" dark :before="[{icon: 'fas fa-user-circle', handler () {}}]" :rules="[val => !!val || 'Username is required']">
                            <template v-slot:prepend>
                                <q-icon name="person" />
                            </template>
                            </q-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col userPassword">
                            <q-input key="text" ref="resetPassword"  v-model="StoreStateAOD.ResetPassword" label="Password" type="password"  color="black" dark :before="[{icon: 'fas fa-user-circle', handler () {}}]" :rules="[ val => val.length >= 6 || 'Password need to be more then 6 characters']">
                                <template v-slot:prepend>
                                    <q-icon name="lock" />
                                </template>
                            </q-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <q-btn style="width:100%"  class="input-group" label="Reset!" type="submit" color="primary"></q-btn>
                        </div>
                    </div>
                </q-form>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import store from '../store'
import { mapState, mapActions } from "vuex";

export default {
    name: 'SATProfileDetails',
    data() {
        return {
            StoreStateCD : store.state.CD,
        StoreStateAOD : store.state.AOD, 
        }
    },
    methods: {
        ...mapActions([
            "UpdateIAccessUsernamePassword"
        ]),

        onSubmit:function(){

            
            this.UpdateIAccessUsernamePassword()
            .then( async res=>{
                if(res===true){
                    this.$q.dialog({
                        title : 'Success',
                    message : 'Weee.. Your password is updated, you may login using the latest credential.'
                    }).onOk(() => {
                        this.$router.push({ name: "AHAM Login"});
                    })

                }else if(res===false){
                     this.$q.dialog({
                        title : 'Error',
                        message : 'Opps. Sorry, something went wrong. Please retry the process.'
                    })
                    .onOk(() => {
                       location.reload();
                     })
                    
                }else {
                     this.$q.dialog({
                        title : 'Error',
                        message : 'Opps. Sorry, Error on API response : ' + res
                    })
                }
            })
          
        }
    },
    mounted() {
        
        this.$refs.resetPassword.focus();
    },
}
</script>